import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  text,
  onClick,
  className = '',
  fullWidth = false,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02,
    boxShadow: '0 0 20px rgba(107, 143, 113, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-sage text-white font-semibold text-lg px-10 py-4 rounded-full
        transition-colors duration-300 hover:bg-[#5a7a5f] focus:outline-none focus:ring-2 focus:ring-sage focus:ring-offset-2 focus:ring-offset-warmBg
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} aria-label={text} data-id="element-40">
      {text}
    </motion.button>;
}